import {Box, Card, CardContent, Container, Divider, Paper, Stack, Typography} from "@mui/material";
import React from "react";
import {useAsync} from "react-async-hook";
import {useParams} from "react-router-dom";
import {isOnlineBookingAvailable, OnlineBookingUnavailableNotice} from "../../booking-utils";
import {AppLayout} from "../../component/app-layout";
import {useSiteApi} from "../../data/sites";
import {BookABoxCta} from "./book-a-box-cta";
import {OpenEntranceCta} from "./open-entrance-cta";
import {OpeningHours} from "./opening-hours";
import {PriceList} from "./price-list";

export function StorefrontPage() {
	const {tenantId, siteId} = useParams<{ tenantId: string; siteId: string }>();
	const {getSite} = useSiteApi();

	const {result: site, loading, error} = useAsync(
		async () => (tenantId && siteId) ? getSite(tenantId, siteId) : undefined,
		[tenantId, siteId],
	);

	return (
		<AppLayout showBrandingBar={true} fillViewport={true} {...{loading, error}}>
			{site && tenantId && siteId && (
				<>
					{/* Scrollable content: site info, opening hours, prices */}
					<Box sx={{flex: 1, minHeight: 0, overflowY: "auto", py: 2}}>
						<Container maxWidth="sm">
							<Card>
								<CardContent>
									<Stack direction="column" gap={3}>
										<Stack direction="column" gap={0.5}>
											<Typography variant="h5">{site.name}</Typography>
											{(site.street || site.city || site.country) && (
												<Typography variant="body2" color="text.secondary">
													{[site.street, site.city, site.country].filter(Boolean).join(", ")}
												</Typography>
											)}
										</Stack>
										<Divider />
										<OpeningHours site={site} />
										<Divider />
										<PriceList site={site} />
									</Stack>
								</CardContent>
							</Card>
						</Container>
					</Box>

					{/* Fixed footer: call-to-action buttons */}
					<Paper square elevation={3} sx={{borderTop: 1, borderColor: "divider"}}>
						<Container maxWidth="sm" sx={{py: 2}}>
							<Stack direction="column" gap={2}>
								<OpenEntranceCta site={site} />
								{isOnlineBookingAvailable(site)
									? <BookABoxCta tenantId={tenantId} siteId={siteId} />
									: <OnlineBookingUnavailableNotice />}
							</Stack>
						</Container>
					</Paper>
				</>
			)}
		</AppLayout>
	);
}
